export default __webpack_public_path__ + "static/media/lakasszovetkezet.5a6fa2a9.svg";